	
(function () {
	'use strict';
	angular.module('app.core')
	.service('priceBreakAnalysisService', priceBreakAnalysisService);

	priceBreakAnalysisService.$inject = ['$http','URLS'];
	
	function priceBreakAnalysisService($http,URLS) {
		var urlPfx = URLS.host + URLS.prefix + globalConfig.factory.id + '/PriceBreakAnalysis/';
		return {
			getPriceBreakAnalysis: getPriceBreakAnalysis,
			getCrossSitePriceBreakAnalysis: getCrossSitePriceBreakAnalysis
		};
		
		function getPriceBreakAnalysis(itemCode) {
			return $http.get(
				urlPfx + 'ItemCode/' + itemCode)
			.then(getPriceBreakAnalysisComplete)
			.catch(getPriceBreakAnalysisFailed);
			function getPriceBreakAnalysisComplete(response) {
				return response.data;
			}
			function getPriceBreakAnalysisFailed(error) {
				return error;
			}
		}
		function getCrossSitePriceBreakAnalysis(itemCode) {
			return $http.get(
				urlPfx + 'CrossSite/ItemCode/' + itemCode)
			.then(getCrossSitePriceBreakAnalysisComplete)
			.catch(getCrossSitePriceBreakAnalysisFailed);
			function getCrossSitePriceBreakAnalysisComplete(response) {
				return response.data;
			}
			function getCrossSitePriceBreakAnalysisFailed(error) {
				return error;
			}
		}
	}
})();